import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
`;

export const Header = styled.div`
  position: relative;
  margin: 0 auto;
  width: 90%;
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`;

export const Title = styled.h2`
  word-wrap: break-word;
  color: #fff;
  margin-top: 0;
  margin-right: 10px;
  font-size: calc(0.24vw + 17.12px);
`;

export const Track = styled.div`
  transform: translate(0%, 0px);
  display: flex;
  width: 15.6167%;
  margin: 0 4.5%;
  overflow: hidden;
  width: 100%;
  /* padding: 20px; */
  /* width: 15.6167%; */
`;
